import { Injectable } from '@angular/core';
import { BasicAuthHeaderFactoryService } from '../../http/headers/basic-auth-header-factory.service';
import { RefreshTokenConfigurationService } from '../../configuration/auth/refresh-token/refresh-token-configuration.service';
import { SuperBatmanHeaderFactoryService } from 'src/app/shared/http/headers/super-batman-header-factory.service';
import { HeaderArrayToHttpHeadersConversionService } from 'src/app/shared/http/headers/header-array-to-http-headers-conversion.service';
import { ContentTypeHeaderFactoryService } from 'src/app/shared/http/headers/content-type-header-factory.service';
import { AuthModule } from '../auth.module';

@Injectable({
  providedIn: AuthModule
})
export class RefreshTokenRequestHeadersFactoryService {

  get addBasicAuthHeaders() {
    return this.refreshTokenConfiguration.addBasicAuthHeader;
  }

  get contentType() {
    return this.refreshTokenConfiguration.contentType;
  }

  get refreshTokenConfiguration() {
    return this.refreshTokenConfigurationService.configuration;
  }

  constructor(private refreshTokenConfigurationService: RefreshTokenConfigurationService,
    private basicAuthHeaderFactoryService: BasicAuthHeaderFactoryService,
    private superBatmanHeaderFactoryService: SuperBatmanHeaderFactoryService,
    private headerArrayToHttpHeadersConversionService: HeaderArrayToHttpHeadersConversionService,
    private contentTypeHeaderFactoryService: ContentTypeHeaderFactoryService) { }

  createHeaders() {
    const array = this.createHeaderArray();
    return this.headerArrayToHttpHeaders(array);
  }

  createSuperBatmanHeader() {
    return this.superBatmanHeaderFactoryService.createHeader();
  }

  createBasicAuthHeader() {
    return this.basicAuthHeaderFactoryService.createHeader();
  }

  createContentTypeHeader() {
    return this.contentTypeHeaderFactoryService.createHeader(this.contentType);
  }

  createHeaderArray() {
    const array = [];

    if (this.addBasicAuthHeaders) {
      array.push(this.createBasicAuthHeader());
    }
    array.push(this.createContentTypeHeader());
    return array;
  }

  headerArrayToHttpHeaders(array) {
    return this.headerArrayToHttpHeadersConversionService.run(array);
  }
}
